<template>
  <div class="box">
    <div v-if="showTitle" class="title">
      <div class="images">
        <img :src="(config && userinfo.portrait) ? config.fileServerUrl + userinfo.portrait : muser" alt=""/>
      </div>
      <div class="btn" v-if="!isLogin">
        <span style="color: #11e011;font-size: 14px;" @click="toJump('Login')">点击登录</span>
      </div>
      <div class="names">
        <p class="nickname font2 f_color1">
          {{ userinfo.nickName }}
        </p>
        <p class="userid font1 f_color2">
          {{
            userinfo.userId
                ? `ID:${userinfo.chatNo ? userinfo.chatNo : userinfo.userId}`
                : ""
          }}
        </p>
      </div>
      <div class="btn" style="margin-left: 20px" v-if="isLogin">
        <span style="color: red;font-size: 14px;position: absolute;right: 20px;" @click="toDel()">退出登录</span>
      </div>
    </div>
    <div class="content font2">
      <div class="listItem lines_bottom" @click="toJump(item.path)" v-for="(item, i) in list" :key="i">
        {{ item.name }}
        <img src="@/assets/image/right.png" alt=""/>
      </div>
    </div>
    <CommonMask v-if="marke"></CommonMask>
  </div>
</template>
<script>
import {showConfirmDialog, showToast} from "vant";
import muser from "@/assets/image/user.png";
// import { wxqq } from "../utils/utils";
import CommonMask from "../components/CommonMask";
import hybrid from "@/utils/hybrid.js";
import baseConfig from "@/models/baseConfig"
// import {showDialog} from "vant/lib/dialog/function-call";

export default {
  name: "HomeView",
  data() {
    return {
      config: null,
      showTitle: false,
      list: [
        // {
        //   name: "充值",
        //   path: "Recharge",
        // },
        {
          name: "提现",
          path: "Withdrawal",
        },
        {
          name: "提现信息",
          path: "WithdrawalInfo",
        }
        // , {
        //   name: "绑定支付宝",
        //   path: "BindAiLiPay",
        // }
        ,
        {
          name: "提现记录",
          path: "WithdrawalRecord",
        },
        {
          name: "提现说明",
          path: "WithdrawalRules",
        }
        //, {
         // name: "测试",
         // path: "WithdrawalData",
        // }
      ],
      isWithdrawInfoBinded: false,
      isLogin: false,
      userinfo: {
        nickName: "",
        userId: "",
        chatNo: "",
        portrait: "",
        isCertified: false,
      },
      muser,
      marke: false,
      read: false
    };
  },
  components: {
    CommonMask,
  },
  created() {
    this.showTitle = !hybrid.isValid
    this.getBaseConfig()
    this.fetchToken()
    if (!this.read) {
      this.initConfig()
    }
  },
  mounted() {
    // this.marke = wxqq();

  },
  methods: {
    initConfig() {

      let that = this
      this.$request.post("/api/trans/withdraw/config").then((res) => {
        if (res.data.code == 0) {

          let wc = res.data.data;
          if (wc.notifications) {
            if (!this.read) {
              this.$notify({
                title: '系统通知',
                message: '' + wc.notifications,
                position: 'bottom-left',
                duration: 3000
              });
              that.read = true
            }
            // showDialog({
            //   title: "系统通知",
            //   message: wc.notifications,
            //   confirmButtonText: "我知道了",
            // })
            //     .then(() => {
            //       that.read = true
            //     })
            //     .catch(() => {
            //     });
          }
        }
      })

    },
    toJump(path) {
      if (!this.isLogin) {
        if (hybrid.isValid) {
          return showToast("正在登录中，请稍后")
        }
        return this.$router.push({path: "Login"})
      }
      switch (path) {
        case "Withdrawal":
          if (!this.userinfo.isCertified) {
            return showToast("在APP上实名认证后才可充值/提现");
          }
          if (!this.isWithdrawInfoBinded) {
            showConfirmDialog({
              title: "绑定账号提示",
              message:
                  "绑定成功后才能提现，是否现在绑定账户？",
              confirmButtonText: "去绑定",
              cancelButtonText: "稍后再说",
            })
                .then(() => {
                  this.$router.push({path: "WithdrawalInfo"});
                })
                .catch(() => {
                });
            return;
          }
          this.$router.push({path: path});
          break;
        case "WithdrawalInfo":
          if (!this.userinfo.isCertified) {
            return showToast("在APP上实名认证后才可充值/提现");
          }
          this.$router.push({path: path});
          break;
        default:
          this.$router.push({path: path});
          break;
      }
    },
    getBaseConfig() {
      baseConfig.getConfig().then((res) => {
        this.config = res;
      })
    },
    fetchToken() {
      let token = sessionStorage.getItem('token')
      if (token != null) {
        this.isLogin = true
        // this.getWithdrawInfoType()
        this.getWithdrawInfo()
        this.getuserinfo()
        return
      }
      const self = this;
      if (hybrid.isValid) {
        hybrid.callNative("getToken", null, function (token) {
          if (token != null && typeof token === 'string' && token.length >= 0) {
            sessionStorage.setItem('token', token);
            self.isLogin = true;
            // self.getWithdrawInfoType();
            self.getWithdrawInfo();
            self.getuserinfo();
          }
        });
      }
    },
    toDel() {
      this.$request.post("/api/user/passport/logout").then(() => {
        sessionStorage.setItem("token", "");
        this.isLogin = false
        this.isWithdrawInfoBinded = false
        this.userinfo = {
          nickName: "",
          userId: "",
          chatNo: "",
          portrait: "",
          isCertified: false
        }
      })
    },
    getWithdrawInfo() {
      this.$request.post("/api/trans/withdraw/sign/info").then((res) => {
        if (res.data.code == 0) {
          this.isWithdrawInfoBinded = !!res.data.data && res.data.data.state === 1;
        }
      })
    },

    getuserinfo() {
      this.$request.post("/api/user/mine/userInfo").then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            this.userinfo = res.data.data;
          }
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.box {
  height: 100%;
  background-color: #f5f5f5;

  .title {
    width: 100%;
    height: 52px;
    padding: 20px 0;
    background-color: #fff;
    display: flex;

    .images {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      margin-left: 20px;
      margin-right: 12px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .btn {
      display: flex;
      align-items: center;
      margin-right: 12px;
    }

    .names {
      p {
        height: 20px;
        line-height: 20px;
      }

      .nickname {
        margin-top: 6px;
      }
    }
  }
}

.content {
  width: 100%;
  background-color: #fff;
  margin-top: 10px;

  .listItem {
    width: 100%;
    height: 55px;
    line-height: 55px;
    padding: 0 20px;
    box-sizing: border-box;

    img {
      width: 6px;
      height: 12px;
      float: right;
      margin-top: 21px;
    }
  }
}
</style>
